import { render, staticRenderFns } from "./TiganTitle.vue?vue&type=template&id=10fc0dd2&scoped=true"
import script from "./TiganTitle.vue?vue&type=script&lang=js"
export * from "./TiganTitle.vue?vue&type=script&lang=js"
import style0 from "./TiganTitle.vue?vue&type=style&index=0&id=10fc0dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc0dd2",
  null
  
)

export default component.exports